<template>
  <gat-lookup-edit
    :label="label || 'Harbour'"
    v-model="model"
    :searchresult="items"
    @getItems="getItems($event)"
    textFieldName="NAME"
    codeFieldName="ID"
    @input="updateValue()"
    @itemNotFound="itemNotFound"
    :cashSearches="true"
    :size="size"
    :required="required"
    :readonly="readonly" />
</template>

<script setup lang="ts">
import { apiCashedGet, apiPost } from '@/store/api';
import { ref, watch } from 'vue';

const props = defineProps({
  value: [String, Number],
  size: String,
  label: String,
  required: Boolean,
  readonly: Boolean,
});

const items = ref([]);
const model = ref<string | number | undefined>(undefined);

const emit = defineEmits(['input', 'item-selected']);

watch(
  () => props.value,
  (val) => {
    model.value = val;
  },
  {
    immediate: true,
  }
);

function getItems(searchText: string) {
  apiPost('helper/search/', { table: 'harbour', text: searchText }).then((data) => {
    // eslint-disable-next-line array-callback-return
    data.map((item: any) => {
      // eslint-disable-next-line no-param-reassign
      // if (item.LOCODE) item.NAME = `${item.NAME} - ${item.LOCODE}`;
      // eslint-disable-next-line no-param-reassign
      item.NAME += `${item.LOCODE ? ` - ${item.LOCODE}` : ''}${item.INACTIVE === 1 ? ' (Inactive)' : ''}`;
    });
    items.value = data;
  });
}

function updateValue() {
  emit('input', model.value);
  const selectedItem = items.value.find((item: any) => item.ID == model.value);
  if (selectedItem) {
    emit('item-selected', selectedItem);
  }
}

function itemNotFound(id: string) {
  apiCashedGet(`helper/harbour/id/${id}`).then((data) => {
    // eslint-disable-next-line array-callback-return
    data.map((item: any) => {
      // eslint-disable-next-line no-param-reassign
      if (item.LOCODE) item.NAME = `${item.NAME} - ${item.LOCODE}`;
    });
    items.value = data;
    if (data && data.length) {
      emit('item-selected', data[0]);
    }
  });
  // }
}
</script>

<style scoped></style>
